import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { TextField, InputLabel, Button } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import axiosInstance, { API_URL } from '../common/Constants';
import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  bg: {
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  content_bg: {
    backgroundColor: '#ffffff',
    margin: '4vh auto',
    width: '100%',
    borderRadius: '20px',
  },
  listItem: {
    fontWeight: 'bold',
  },
  radioGroup: {
    '& label:first-child': {
      paddingRight: '20%',
      [theme.breakpoints.down('sm')]: {
        paddingRight: 0,
      },
    },
  },
  radioOuter: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 0',
    '& .MuiFormGroup-row': {
      display: 'flex',
      justifyContent: 'center',
    },
  },

  InputLabel: {
    color: '#000',
    paddingBottom: '10px',
  },
  asterisk: {
    color: theme.palette.primary.point,
    fontWeight: 'bold',
    paddingLeft: '5px',
  },
  InqCate: {
    width: '90%',
  },
});

const StyledRadio = withStyles((theme) => ({
  root: {
    color: '#e8e8e8',
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
}))((props) => <Radio color="default" {...props} />);

class Inquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      value: 0,
      name: null,
      contact: null,
      company: null,
      position: null,
      email: null,
      title: null,
      content: null,
      isEstimate: false,
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.changeCate = this.changeCate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem('loggedin')) {
      this.getUserInfo(localStorage.getItem('loggedin'));
    }
  }

  getUserInfo(id) {
    axiosInstance
      .get(`${API_URL}/user/info?userId=${id}`, {})
      .then((res) => {
        if (res.data.name) {
          this.setState({ name: res.data.name });
        }
        if (res.data.phone) {
          this.setState({ contact: res.data.phone });
        }
        if (res.data.email) {
          this.setState({ email: res.data.email });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleChange(type, event) {
    this.setState({ [type]: event.target.value });
  }

  validatePhone() {
    const p = this.state.contact.split('-').join('');
    if (/^01([0|1|6|7|8|9]?)(\d{3,4})(\d{4})$/.test(p)) {
      return true;
    } else {
      return false;
    }
  }
  validateEmail() {
    const re = /\S+@\S+\.\S+/;
    const email = this.state.email;
    if (this.state.isEstimate) {
      return re.test(email);
    } else {
      return true;
    }
  }

  onSubmit() {
    if (!this.validatePhone()) {
      swal({
        text: '유효하지 않은 휴대폰 번호입니다.',
        icon: 'warning',
      });
      return false;
    } else if (!this.validateEmail()) {
      swal({
        text: '이메일 형식이 올바르지 않습니다.',
        icon: 'warning',
      });
      return false;
    } else {
      const { isEstimate, name, contact, company, position, email, title, content } = this.state;
      let param = isEstimate
        ? {
            title: title,
            content: content,
            username: name,
            tel: contact,
            company: company,
            dept: position,
            email: email,
            isEstimate: isEstimate,
          }
        : {
            title: title,
            content: content,
            username: name,
            tel: contact,
            isEstimate: isEstimate,
          };
      swal({
        text: '문의사항을 등록하시겠습니까?',
        button: '확인',
      }).then(() => {
        axiosInstance
          .post(`${API_URL}/qna/`, param, {})
          .then((res) => {
            if (res.status === 200) {
              swal({
                text: '정상적으로 등록되었습니다.',
                icon: 'success',
              }).then(() => {
                this.setState({ contact: '', company: '', position: '', title: '', content: '' });
              });
            } else {
              swal({
                text: '등록에 실패하였습니다.',
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  }
  changeCate(event) {
    if (!localStorage.getItem('loggedin')) {
      this.setState({
        contact: '',
        email: '',
      });
    }
    this.setState({
      isEstimate: !this.state.isEstimate,
      company: '',
      position: '',
      title: '',
      content: '',
    });
  }
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid item xs={10} className={classes.content_bg}>
            <TitleText title="1:1 문의사항" />
            <div style={{ padding: '0 10vw' }}>
              <FormControl className={classes.radioOuter}>
                <RadioGroup row value={this.state.isEstimate} onChange={this.changeCate} className={classes.radioGroup}>
                  <FormControlLabel value={false} control={<StyledRadio />} label="일반문의" />
                  <FormControlLabel value={true} control={<StyledRadio />} label="견적문의" />
                </RadioGroup>
              </FormControl>

              <Grid container justify="center" style={{ paddingBottom: '30px', color: '#999999', textAlign: 'center' }}>
                사업 및 견적 문의 등 문의내용을 작성하여 보내주시면, 확인 후 연락드리겠습니다.
              </Grid>
              <Grid container spacing={3} style={{ paddingBottom: '30px' }}>
                <Grid item xs={12} sm={6}>
                  <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                    이름<span className={classes.asterisk}>*</span>
                  </InputLabel>
                  <TextField
                    type="text"
                    value={this.state.name}
                    fullWidth={true}
                    variant="outlined"
                    onChange={(event) => this.handleChange('name', event)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                    휴대폰 번호<span className={classes.asterisk}>*</span>
                  </InputLabel>
                  <TextField
                    type="tel"
                    value={this.state.contact}
                    fullWidth={true}
                    variant="outlined"
                    onChange={(event) => this.handleChange('contact', event)}
                  />
                </Grid>
                {this.state.isEstimate ? (
                  <>
                    <Grid item xs={12} sm={4}>
                      <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                        소속<span className={classes.asterisk}>*</span>
                      </InputLabel>
                      <TextField
                        type="text"
                        value={this.state.company}
                        fullWidth={true}
                        variant="outlined"
                        onChange={(event) => this.handleChange('company', event)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                        부서/직급<span className={classes.asterisk}>*</span>
                      </InputLabel>
                      <TextField
                        type="text"
                        value={this.state.position}
                        fullWidth={true}
                        variant="outlined"
                        onChange={(event) => this.handleChange('position', event)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                        이메일<span className={classes.asterisk}>*</span>
                      </InputLabel>
                      <TextField
                        type="email"
                        value={this.state.email}
                        fullWidth={true}
                        variant="outlined"
                        onChange={(event) => this.handleChange('email', event)}
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                <Grid item xs={12}>
                  <InputLabel variant="standard" filled className={classes.InputLabel} style={{ color: '#000' }}>
                    제목<span className={classes.asterisk}>*</span>
                  </InputLabel>
                  <TextField
                    type="text"
                    value={this.state.title}
                    fullWidth={true}
                    variant="outlined"
                    onChange={(event) => this.handleChange('title', event)}
                  />
                  <TextField
                    fullWidth={true}
                    placeholder="문의하실 내용을 입력해주세요."
                    onChange={(event) => this.handleChange('content', event)}
                    variant="outlined"
                    multiline={true}
                    rows={7}
                    value={this.state.content}
                    style={{
                      marginTop: '25px',
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container justify="center">
                <Button
                  disableElevation
                  variant="contained"
                  color="primary"
                  style={{
                    width: this.state.matches ? '100%' : '30%',
                    padding: '15px',
                    marginBottom: 100,
                    color: '#fff',
                    fontWeight: 'bold',
                    borderRadius: '30px',
                  }}
                  onClick={this.onSubmit}
                  disabled={
                    !this.state.isEstimate
                      ? !this.state.name || !this.state.contact || !this.state.title || !this.state.content
                      : !this.state.name ||
                        !this.state.contact ||
                        !this.state.company ||
                        !this.state.position ||
                        !this.state.email ||
                        !this.state.title ||
                        !this.state.content
                  }
                >
                  전 송
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default withRouter(withStyles(styles, { withTheme: true })(Inquiry));
